module.exports = __webpack_public_path__ + "img/4.aae32689.png";